import React from 'react';
import { AccordionSection } from '@quintype/em/components/accordion';
import get from 'lodash/get';
import { updateMeterWallSettings, renderAccordionSection, meteringOffShortCodes } from '../payWallUtils';

// metering off storiesBehindLogin
export function storiesBehindLogin(modules: any, formats: any, pageSetting: any, dispatch: any): JSX.Element {
  const config = [
    {
      type: 'hintText',
      text: 'Use this if you have Turned OFF metering for stories that are behind login.'
    },
    {
      type: 'quillEditor',
      label: 'Registration wall title',
      placeholder: 'Sign up to gain access to this article.',
      value: get(pageSetting, ['meteringOff', 'login', 'wallTitle']) || '',
      onChange: (value: any) => updateMeterWallSettings('meteringOff', '', 'login', '', 'wallTitle', value, dispatch)
    },
    {
      type: 'quillEditor',
      label: 'Registration wall description',
      placeholder: 'To read more articles and enjoy an uninterrupted reading experience, please sign up with us.',
      value: get(pageSetting, ['meteringOff', 'login', 'wallDescription']) || '',
      onChange: (value: any) =>
        updateMeterWallSettings('meteringOff', '', 'login', '', 'wallDescription', value, dispatch)
    },
    {
      type: 'text',
      label: 'Sign up',
      placeholder: 'Sign up',
      value: get(pageSetting, ['meteringOff', 'login', 'buttonTxt']) || '',
      onChange: (value: any) => updateMeterWallSettings('meteringOff', '', 'login', '', 'buttonTxt', value, dispatch)
    },
    {
      type: 'text',
      label: 'Sign in',
      placeholder: 'Sign in',
      value: get(pageSetting, ['meteringOff', 'login', 'signInTxt']) || '',
      onChange: (value: any) => updateMeterWallSettings('meteringOff', '', 'login', '', 'signInTxt', value, dispatch)
    },
    {
      type: 'text',
      label: 'Already have an account? Sign in',
      placeholder: 'Already have an account? [Sign in]',
      value: get(pageSetting, ['meteringOff', 'login', 'bottomTxt']) || '',
      onChange: (value: string) => updateMeterWallSettings('meteringOff', '', 'login', '', 'bottomTxt', value, dispatch)
    }
  ];
  return (
    <AccordionSection label={'stories behind login'} isLabelUpperCase index={0}>
      {renderAccordionSection(config, modules, formats)}
      {meteringOffShortCodes()}
    </AccordionSection>
  );
}
